import { type JSX } from 'react';
import { twMerge } from 'tailwind-merge';

import { Label } from '@videoblocks/design-system';

import { InfoButtonTooltip } from '../InfoButtonTooltip';
import { ModelSelect, ModelSelectProps } from '../ModelSelect/ModelSelect';

export type ModelSelectFieldProps = ModelSelectProps & { disabledReason?: string };

export const ModelSelectField = ({ className, disabledReason, ...rest }: ModelSelectFieldProps): JSX.Element => {
    return (
        <div className={twMerge('flex flex-col gap-2', className)}>
            <div className="flex items-center gap-2">
                <Label htmlFor="model-select" className="text-left" fontSize="sm">
                    Model
                </Label>
                {disabledReason && <InfoButtonTooltip title={disabledReason} label="Model" />}
            </div>
            <ModelSelect id="model-select" name="model-select" className="w-full max-w-none" {...rest} />
        </div>
    );
};
